import { render } from "./PaymentStatus.vue?vue&type=template&id=0a7dd604&ts=true"
import script from "./PaymentStatus.ts?vue&type=script&lang=ts"
export * from "./PaymentStatus.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__